// This file is automatically generated. Do not edit manually.

import { CustomerOrderProfitMarginView } from "src/api/generated/erp/db/types/tables/customerOrderProfitMarginView";
import { PriceRecalculationResult } from "src/api/generated/erp/sales/pricing/service/priceRecalculationResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderProfitMarginApi {
	export async function getProfitMargins(args: {
		customerOrderId: number;
	}): Promise<Array<CustomerOrderProfitMarginView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/profitMargins/getProfitMargins",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as Array<CustomerOrderProfitMarginView>;
	}

	export async function saveProfitMargins(args: {
		customerOrderId: number;
		rows: Array<CustomerOrderProfitMarginApi_SaveRow>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/profitMargins/saveProfitMargins",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				rows: args.rows,
			},
		});
		return response as void;
	}

	export async function recalculatePrices(args: { customerOrderId: number }): Promise<PriceRecalculationResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/profitMargins/recalculatePrices",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as PriceRecalculationResult;
	}

	export async function acknowledgePriceRecalculation(args: { customerOrderId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrder/profitMargins/acknowledgePriceRecalculation",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
			},
		});
		return response as void;
	}
}

export interface CustomerOrderProfitMarginApi_SaveRow {
	profitMarginPercent: number | null | undefined;
	salesPartPriceGroupId: number;
}
